import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/disciplinary-activities', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/disciplinary-activities', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const find = (id, Options = {}) => {
  return httpClient
    .get(`/api/disciplinary-activities/${id}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const update = data => {
  return httpClient
    .put(`/api/disciplinary-activities/${data.dis_activity_id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const destroy = id => {
  return httpClient
    .delete(`/api/disciplinary-activities/${id}`)
    .then(response => Promise.resolve(response.data))
}

export const penalty = (Options = {}) => {
  return httpClient
    .get('/api/disciplinary-activities/penalty-types', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default {
  get,
  find,
  store,
  update,
  destroy,
  penalty
}
